"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7298,6719,4435],{

/***/ 67814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ FontAwesomeIcon; }
/* harmony export */ });
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23636);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded);

  mixins.attrs['style'] = _objectSpread2(_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.icon */ .Qc.icon) {
    return _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.icon */ .Qc.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}

var FontAwesomeIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.transform */ .Qc.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = (0,_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .icon */ .qv)(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: ref
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  border: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  beatFade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  bounce: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flash: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  mask: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  maskId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fixedWidth: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  inverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flip: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  listItem: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  pull: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['right', 'left']),
  pulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  rotation: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([0, 90, 180, 270]),
  shake: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinPulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinReverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  symbol: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  titleId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  transform: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)]),
  swapOpacity: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, react__WEBPACK_IMPORTED_MODULE_1__.createElement);




/***/ }),

/***/ 16719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CustomButtons_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/makeStyles.js
var makeStyles = __webpack_require__(32427);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./styles/jss/bbhost.js
var bbhost = __webpack_require__(21086);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/buttonStyle.js

var buttonStyle = {
    button: {
        minHeight: "auto",
        minWidth: "auto",
        backgroundColor: bbhost/* grayColor */.X_,
        color: "#FFFFFF",
        boxShadow: "0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
        border: "none",
        borderRadius: "3px",
        position: "relative",
        padding: "12px 30px",
        margin: ".3125rem 1px",
        fontSize: "12px",
        fontWeight: "400",
        textTransform: "uppercase",
        letterSpacing: "0",
        willChange: "box-shadow, transform",
        transition: "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        lineHeight: "1.42857143",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        touchAction: "manipulation",
        cursor: "pointer",
        "&:hover,&:focus": {
            color: "#FFFFFF",
            backgroundColor: bbhost/* grayColor */.X_,
            boxShadow: "0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            position: "relative",
            display: "inline-block",
            top: "0",
            fontSize: "1.1rem",
            marginRight: "4px",
            verticalAlign: "middle"
        },
        "& svg": {
            position: "relative",
            display: "inline-block",
            top: "0",
            width: "18px",
            height: "18px",
            marginRight: "4px",
            verticalAlign: "middle"
        },
        "&$justIcon": {
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                marginRight: "0px",
                position: "absolute",
                width: "100%",
                transform: "none",
                left: "0px",
                top: "0px",
                height: "100%",
                lineHeight: "41px",
                fontSize: "20px"
            }
        }
    },
    fullWidth: {
        width: "100%"
    },
    primary: {
        backgroundColor: bbhost/* primaryColor */.lr,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* primaryColor */.lr,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2))
        }
    },
    info: {
        backgroundColor: bbhost/* infoColor */.bE,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* infoColor */.bE,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.2))
        }
    },
    success: {
        backgroundColor: bbhost/* successColor */.nq,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* successColor */.nq,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.2))
        }
    },
    warning: {
        backgroundColor: bbhost/* warningColor */.MA,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* warningColor */.MA,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.2))
        }
    },
    danger: {
        backgroundColor: bbhost/* dangerColor */.E7,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* dangerColor */.E7,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.2))
        }
    },
    rose: {
        backgroundColor: bbhost/* roseColor */.An,
        boxShadow: "0 2px 2px 0 ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.14), ", 0 3px 1px -2px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2), ", 0 1px 5px 0 ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.12)),
        "&:hover,&:focus": {
            backgroundColor: bbhost/* roseColor */.An,
            boxShadow: "0 14px 26px -12px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.42), ", 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px ").concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.2))
        }
    },
    white: {
        "&,&:focus,&:hover,&:visited": {
            backgroundColor: "#FFFFFF",
            color: bbhost/* grayColor */.X_
        }
    },
    twitter: {
        backgroundColor: "#55acee",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(85, 172, 238, 0.14), 0 3px 1px -2px rgba(85, 172, 238, 0.2), 0 1px 5px 0 rgba(85, 172, 238, 0.12)",
        "&:hover,&:focus,&:visited": {
            backgroundColor: "#55acee",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(85, 172, 238, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(85, 172, 238, 0.2)"
        }
    },
    facebook: {
        backgroundColor: "#3b5998",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(59, 89, 152, 0.14), 0 3px 1px -2px rgba(59, 89, 152, 0.2), 0 1px 5px 0 rgba(59, 89, 152, 0.12)",
        "&:hover,&:focus": {
            backgroundColor: "#3b5998",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(59, 89, 152, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2)"
        }
    },
    google: {
        backgroundColor: "#dd4b39",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)",
        "&:hover,&:focus": {
            backgroundColor: "#dd4b39",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)"
        }
    },
    github: {
        backgroundColor: "#333333",
        color: "#fff",
        boxShadow: "0 2px 2px 0 rgba(51, 51, 51, 0.14), 0 3px 1px -2px rgba(51, 51, 51, 0.2), 0 1px 5px 0 rgba(51, 51, 51, 0.12)",
        "&:hover,&:focus": {
            backgroundColor: "#333333",
            color: "#fff",
            boxShadow: "0 14px 26px -12px rgba(51, 51, 51, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(51, 51, 51, 0.2)"
        }
    },
    simple: {
        "&,&:focus,&:hover,&:visited": {
            color: "#FFFFFF",
            background: "transparent",
            boxShadow: "none"
        },
        "&$primary": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* primaryColor */.lr
            }
        },
        "&$info": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* infoColor */.bE
            }
        },
        "&$success": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* successColor */.nq
            }
        },
        "&$warning": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* warningColor */.MA
            }
        },
        "&$rose": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* roseColor */.An
            }
        },
        "&$danger": {
            "&,&:focus,&:hover,&:visited": {
                color: bbhost/* dangerColor */.E7
            }
        },
        "&$twitter": {
            "&,&:focus,&:hover,&:visited": {
                color: "#55acee"
            }
        },
        "&$facebook": {
            "&,&:focus,&:hover,&:visited": {
                color: "#3b5998"
            }
        },
        "&$google": {
            "&,&:focus,&:hover,&:visited": {
                color: "#dd4b39"
            }
        },
        "&$github": {
            "&,&:focus,&:hover,&:visited": {
                color: "#333333"
            }
        }
    },
    transparent: {
        "&,&:focus,&:hover,&:visited": {
            color: "inherit",
            background: "transparent",
            boxShadow: "none"
        }
    },
    disabled: {
        opacity: "0.65",
        pointerEvents: "none"
    },
    lg: {
        padding: "1.125rem 2.25rem",
        fontSize: "0.875rem",
        lineHeight: "1.333333",
        borderRadius: "0.2rem"
    },
    sm: {
        padding: "0.40625rem 1.25rem",
        fontSize: "0.6875rem",
        lineHeight: "1.5",
        borderRadius: "0.2rem"
    },
    round: {
        borderRadius: "30px"
    },
    block: {
        width: "100% !important"
    },
    link: {
        "&,&:hover,&:focus": {
            backgroundColor: "transparent",
            color: "#999999",
            boxShadow: "none"
        }
    },
    justIcon: {
        paddingLeft: "12px",
        paddingRight: "12px",
        fontSize: "20px",
        height: "41px",
        minWidth: "41px",
        width: "41px",
        "& .fab,& .fas,& .far,& .fal,& svg,& .material-icons": {
            marginRight: "0px"
        },
        "&$lg": {
            height: "57px",
            minWidth: "57px",
            width: "57px",
            lineHeight: "56px",
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "32px",
                lineHeight: "56px"
            },
            "& svg": {
                width: "32px",
                height: "32px"
            }
        },
        "&$sm": {
            height: "30px",
            minWidth: "30px",
            width: "30px",
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "17px",
                lineHeight: "29px"
            },
            "& svg": {
                width: "17px",
                height: "17px"
            }
        }
    }
};
/* harmony default export */ var components_buttonStyle = (buttonStyle);

;// CONCATENATED MODULE: ./components/CustomButtons/Button.js






// nodejs library to set properties for components

// nodejs library that concatenates classes

// @material-ui/core components


// core components

var makeComponentStyles = (0,makeStyles/* default */.Z)(function() {
    return (0,_object_spread/* default */.Z)({}, components_buttonStyle);
});
var RegularButton = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var color = props.color, round = props.round, children = props.children, fullWidth = props.fullWidth, disabled = props.disabled, simple = props.simple, size = props.size, block = props.block, link = props.link, justIcon = props.justIcon, className = props.className, rest = (0,_object_without_properties/* default */.Z)(props, [
        "color",
        "round",
        "children",
        "fullWidth",
        "disabled",
        "simple",
        "size",
        "block",
        "link",
        "justIcon",
        "className"
    ]);
    var classes = makeComponentStyles();
    var _obj;
    var btnClasses = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.button, true), (0,_define_property/* default */.Z)(_obj, classes[size], size), (0,_define_property/* default */.Z)(_obj, classes[color], color), (0,_define_property/* default */.Z)(_obj, classes.round, round), (0,_define_property/* default */.Z)(_obj, classes.fullWidth, fullWidth), (0,_define_property/* default */.Z)(_obj, classes.disabled, disabled), (0,_define_property/* default */.Z)(_obj, classes.simple, simple), (0,_define_property/* default */.Z)(_obj, classes.block, block), (0,_define_property/* default */.Z)(_obj, classes.link, link), (0,_define_property/* default */.Z)(_obj, classes.justIcon, justIcon), (0,_define_property/* default */.Z)(_obj, className, className), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        ref: ref,
        classes: {
            root: btnClasses
        },
        children: children
    }));
});
RegularButton.propTypes = {
    color: prop_types_default().oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "rose",
        "white",
        "facebook",
        "twitter",
        "google",
        "github",
        "transparent", 
    ]),
    size: prop_types_default().oneOf([
        "sm",
        "lg"
    ]),
    simple: (prop_types_default()).bool,
    round: (prop_types_default()).bool,
    fullWidth: (prop_types_default()).bool,
    disabled: (prop_types_default()).bool,
    block: (prop_types_default()).bool,
    link: (prop_types_default()).bool,
    justIcon: (prop_types_default()).bool,
    children: (prop_types_default()).node,
    className: (prop_types_default()).string
};
RegularButton.displayName = "RegularButton";
/* harmony default export */ var CustomButtons_Button = (RegularButton);


/***/ }),

/***/ 37298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./components/Grid/GridContainer.js
var GridContainer = __webpack_require__(64041);
// EXTERNAL MODULE: ./components/Grid/GridItem.js
var GridItem = __webpack_require__(96680);
// EXTERNAL MODULE: ./styles/jss/bbhost.js
var bbhost = __webpack_require__(21086);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/footerStyle.js

var footerStyle = {
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block"
    },
    left: {
        float: "left!important",
        display: "block"
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right!important"
    },
    footer: {
        padding: "0.9375rem 0",
        textAlign: "center",
        display: "flex",
        zIndex: "2",
        position: "relative"
    },
    a: {
        color: bbhost/* primaryColor */.lr,
        textDecoration: "none",
        backgroundColor: "transparent"
    },
    footerWhiteFont: {
        "&,&:hover,&:focus": {
            color: "#FFFFFF"
        }
    },
    container: bbhost/* container */.nC,
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0"
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto"
    },
    icon: {
        width: "18px",
        height: "18px",
        position: "relative",
        top: "3px"
    }
};
/* harmony default export */ var components_footerStyle = (footerStyle);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./components/CustomButtons/Button.js + 1 modules
var Button = __webpack_require__(16719);
// EXTERNAL MODULE: ./lang/lang.js + 3 modules
var lang = __webpack_require__(34426);
;// CONCATENATED MODULE: ./components/Footer/LinkAreaItem.js


// core components


function LinkAreaItem(param) {
    var text = param.text, href = param.href, type = param.type, color = param.color, locale = param.locale;
    if (typeof text === "object") {
        text = (0,lang/* getLangFromObj */.x)(text, locale);
    }
    if (type === "external") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
        href: href,
        target: "_blank",
        size: "sm",
        color: color,
        children: text
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
        href: href,
        size: "sm",
        color: color,
        children: text
    });
}

// EXTERNAL MODULE: ./configs/index.js + 16 modules
var configs = __webpack_require__(91856);
;// CONCATENATED MODULE: ./components/Footer/FooterLinkArea.js






var styles = (0,_object_spread/* default */.Z)({}, components_footerStyle);


function FooterLinkArea(param) {
    var locale = param.locale;
    var links = configs/* LINKS.map */.BA.map(function(link, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkAreaItem, {
            href: link.link,
            text: link.text,
            type: link.type,
            locale: locale,
            color: "transparent"
        }, link.name);
    });
    if (links.length > 0) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridItem["default"], {
        xs: 12,
        sm: 12,
        md: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: (0,lang/* trans */.d)("footer::links.title", locale)
            }),
            links
        ]
    });
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

;// CONCATENATED MODULE: ./components/Footer/FooterSocialArea.js








var FooterSocialArea_styles = (0,_object_spread/* default */.Z)({}, components_footerStyle);
var useStyles = (0,makeStyles/* default */.Z)(FooterSocialArea_styles);


function FooterSocialArea(param) {
    var locale = param.locale;
    var classes = useStyles();
    var links = configs/* SOCIAL.map */.k1.map(function(link, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button["default"], {
            href: link.route,
            simple: true,
            target: "_blank",
            size: "sm",
            color: link.color,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: link.icon,
                    size: "lg"
                }),
                " ",
                link.text
            ]
        }, link.name);
    });
    if (links.length > 0) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridItem["default"], {
        xs: 6,
        sm: 6,
        md: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: (0,lang/* trans */.d)("footer::social.title", locale)
            }),
            links
        ]
    });
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(5950);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./constants.js
var constants = __webpack_require__(68148);
;// CONCATENATED MODULE: ./components/Functions/StatusPage.js








var StatusPage_Button = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16719));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16719)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Carregando.."
        });
    }
});
var PriorityHighIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2781).then(__webpack_require__.bind(__webpack_require__, 2781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2781)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Carregando.."
        });
    }
});
var CheckIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1959).then(__webpack_require__.bind(__webpack_require__, 41959));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41959)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Carregando.."
        });
    }
});
var WarningIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1727).then(__webpack_require__.bind(__webpack_require__, 21727));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21727)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Carregando.."
        });
    }
});
var ErrorOutlineIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8740).then(__webpack_require__.bind(__webpack_require__, 38740));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38740)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Carregando.."
        });
    }
});


function getAlert(status, locale) {
    var alert = {
        none: {
            text: (0,lang/* trans */.d)("footer::status.ok", locale),
            color: "success",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
        },
        ok: {
            text: (0,lang/* trans */.d)("footer::status.ok", locale),
            color: "success",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
        },
        minor: {
            text: (0,lang/* trans */.d)("footer::status.warning", locale),
            color: "warning",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon, {})
        },
        major: {
            text: (0,lang/* trans */.d)("footer::status.danger", locale),
            color: "danger",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlineIcon, {})
        },
        critical: {
            text: (0,lang/* trans */.d)("footer::status.danger", locale),
            color: "danger",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlineIcon, {})
        },
        maintenance: {
            text: (0,lang/* trans */.d)("footer::status.maintenance", locale),
            color: "info",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityHighIcon, {})
        }
    };
    return alert[status];
}
var StatusPage = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(StatusPage, Component);
    var _super = (0,_create_super/* default */.Z)(StatusPage);
    function StatusPage(props) {
        (0,_class_call_check/* default */.Z)(this, StatusPage);
        var _this;
        _this = _super.call(this, props);
        _this.locale = props.locale;
        _this.state = {
            status: [],
            link: ""
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(StatusPage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.checkStatus();
            }
        },
        {
            key: "checkStatus",
            value: function checkStatus() {
                var _this = this;
                var requestConfig = {
                    url: "/status.json?timestamp=".concat(new Date().getTime()),
                    baseURL: constants/* STATUSPAGE_API */.Vt,
                    timeout: 1000
                };
                this.axios = axios/* default.create */.Z.create(requestConfig);
                this.axios.request(requestConfig).then(function(response) {
                    var alertObj = getAlert(response.data.status.indicator, _this.locale);
                    _this.setState({
                        status: alertObj,
                        link: response.data.page.url
                    });
                });
            }
        },
        {
            key: "getUrl",
            value: function getUrl(endpoint) {
                return "".concat(constants/* STATUSPAGE_API */.Vt).concat(endpoint, "?timestamp=").concat(new Date().getTime());
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatusPage_Button, {
                        target: "_blank",
                        href: this.state.link,
                        color: this.state.status.color,
                        simple: true,
                        children: [
                            this.state.status.icon,
                            " ",
                            this.state.status.text
                        ]
                    })
                });
            }
        }
    ]);
    return StatusPage;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./styles/jss/bbhost/imagesStyles.js
var imagesStyles = __webpack_require__(89395);
;// CONCATENATED MODULE: ./styles/jss/bbhost/pages/componentsSections/typographyStyle.js




var typographyStyle = (0,_object_spread/* default */.Z)({
    section: {
        padding: "70px 0"
    },
    container: bbhost/* container */.nC,
    space50: {
        height: "50px",
        display: "block"
    },
    title: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bbhost/* title */.TN), {
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
    }),
    typo: {
        paddingLeft: "25%",
        marginBottom: "40px",
        position: "relative",
        width: "100%"
    },
    note: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        bottom: "10px",
        color: "#c0c1c2",
        display: "block",
        fontWeight: "400",
        fontSize: "13px",
        lineHeight: "13px",
        left: "0",
        marginLeft: "20px",
        position: "absolute",
        width: "260px"
    },
    marginLeft: {
        marginLeft: "auto !important"
    }
}, imagesStyles/* default */.Z);
/* harmony default export */ var componentsSections_typographyStyle = (typographyStyle);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./styles/jss/bbhost/tooltipsStyle.js
var tooltipsStyle = __webpack_require__(39832);
;// CONCATENATED MODULE: ./components/Footer/CertificationItem.js





// material-ui components


// core components


var CertificationItem_styles = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltipsStyle/* default */.Z), {
    maxWidth: "500px"
});
var CertificationItem_useStyles = (0,makeStyles/* default */.Z)(CertificationItem_styles);

function CertificationItem(param) {
    var name = param.name, text = param.text, href = param.href, children = param.children;
    var classes = CertificationItem_useStyles();
    if (typeof text === "object") {
        text = (0,lang/* getLangFromObj */.x)(text);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        id: "tooltip-top_" + name,
        title: text,
        placement: "top",
        classes: {
            tooltip: classes.tooltip
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
            color: "transparent",
            href: href,
            target: "_blank",
            size: "sm",
            width: "50%",
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./components/Footer/Certifications.js












var Certifications_styles = (0,_object_spread/* default */.Z)({}, componentsSections_typographyStyle);
var Certifications_useStyles = (0,makeStyles/* default */.Z)(Certifications_styles);


function Certifications(param) {
    var locale = param.locale;
    var certifications = configs/* CERTIFICATIONS.map */.xf.map(function(certification, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CertificationItem, {
            name: certification.name,
            text: certification.subText,
            href: certification.link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: certification.logo,
                alt: certification.text,
                width: certification.width,
                height: certification.height,
                layout: "fixed"
            })
        }, key);
    });
    if (certifications.length > 0) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridItem["default"], {
        xs: 6,
        sm: 6,
        md: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: (0,lang/* trans */.d)("footer::certifications.title", locale)
            }),
            certifications
        ]
    });
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/Footer/Footer.js
/*eslint-disable*/ 



// nodejs library to set properties for components

// nodejs library that concatenates classes












var Footer_useStyles = (0,makeStyles/* default */.Z)(components_footerStyle);


function Footer(props) {
    var classes = Footer_useStyles();
    var locale = (0,router.useRouter)().locale;
    var whiteFont = props.whiteFont, blocked = props.blocked;
    var _obj;
    var footerClasses = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.footer, true), (0,_define_property/* default */.Z)(_obj, classes.footerWhiteFont, whiteFont), _obj));
    var _obj1;
    var aClasses = classnames_default()((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, classes.a, true), (0,_define_property/* default */.Z)(_obj1, classes.footerWhiteFont, whiteFont), _obj1));
    var contatArea = configs/* CONTATO.map */.Ms.map(function(contato, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button["default"], {
            href: contato.route,
            simple: true,
            target: "_blank",
            size: "sm",
            color: contato.color,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: contato.icon,
                    size: "lg"
                }),
                " ",
                contato.text
            ]
        }, contato.name);
    });
    if (blocked) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            className: footerClasses,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer["default"], {
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem["default"], {
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusPage, {
                                    locale: locale
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem["default"], {
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    (0,lang/* trans */.d)("footer::copy"),
                                    " \xa9 2013 - ",
                                    1900 + new Date().getYear()
                                ]
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: footerClasses,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer["default"], {
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Certifications, {
                            locale: locale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinkArea, {
                            locale: locale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialArea, {
                            locale: locale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridItem["default"], {
                            xs: 12,
                            sm: 12,
                            md: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: (0,lang/* trans */.d)("footer::contato.title")
                                }),
                                contatArea
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer["default"], {
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem["default"], {
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusPage, {
                                    locale: locale
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem["default"], {
                            xs: 12,
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    (0,lang/* trans */.d)("footer::copy"),
                                    " \xa9 2013 - ",
                                    1900 + new Date().getYear()
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer["default"], {
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem["default"], {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle2",
                            children: "BB Host LTDA - CNPJ 27.041.737/0001-09"
                        })
                    })
                })
            ]
        })
    });
}
Footer.propTypes = {
    whiteFont: (prop_types_default()).bool,
    blocked: (prop_types_default()).bool
};


/***/ }),

/***/ 64041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GridContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41749);





// nodejs library to set properties for components

// @material-ui/core components


var styles = {
    grid: {
        marginRight: "-15px",
        marginLeft: "-15px",
        width: "auto"
    }
};
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles);
function GridContainer(props) {
    var classes = useStyles();
    var children = props.children, className = props.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        container: true
    }, rest), {
        className: classes.grid + " " + className,
        children: children
    }));
}
GridContainer.defaultProps = {
    className: ""
};
GridContainer.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};


/***/ }),

/***/ 96680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GridItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41749);





// nodejs library to set properties for components

// @material-ui/core components


var styles = {
    grid: {
        position: "relative",
        width: "100%",
        minHeight: "1px",
        paddingRight: "15px",
        paddingLeft: "15px",
        flexBasis: "auto"
    }
};
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles);
function GridItem(props) {
    var classes = useStyles();
    var children = props.children, className = props.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        item: true
    }, rest), {
        className: classes.grid + " " + className,
        children: children
    }));
}
GridItem.defaultProps = {
    className: ""
};
GridItem.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};


/***/ })

}]);